import { useState } from "react";
import Reveal from "@/components/base/Reveal";
import { endingTabs } from "@/mocks/drama";

export default function EndingTabs() {
  const [activeId, setActiveId] = useState(endingTabs[0].id);
  const active = endingTabs.find((tab) => tab.id === activeId) ?? endingTabs[0];

  return (
    <section className="w-full bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <Reveal>
          <div className="max-w-2xl">
            <p className="flex items-center gap-2 font-label text-sm tracking-[0.3em] text-primary-600">
              <i className="ri-chat-3-line" />
              结 局 是 什 么
            </p>
            <h2 className="mt-4 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-4xl">
              四个角度读懂结局
            </h2>
            <p className="mt-5 text-sm leading-relaxed text-foreground-600 md:text-base">
              结局不是只有一种读法。切换下面的标签，可以分别从主线归宿、对立者下场、隐藏伏笔与开放式解读四个方向去理解。
            </p>
          </div>
        </Reveal>

        <Reveal delay={80}>
          <div className="mt-8 inline-flex flex-wrap gap-1 rounded-full border border-background-200 bg-background-100 p-1">
            {endingTabs.map((tab) => (
              <button
                key={tab.id}
                type="button"
                onClick={() => setActiveId(tab.id)}
                className={`whitespace-nowrap rounded-full px-4 py-1.5 text-sm font-medium transition ${
                  activeId === tab.id
                    ? "bg-primary-500 text-background-50"
                    : "text-foreground-600 hover:bg-background-200"
                }`}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </Reveal>

        <Reveal delay={120}>
          <div className="mt-8 grid grid-cols-1 gap-8 rounded-lg border border-background-200 bg-background-100 p-6 md:p-10 lg:grid-cols-12">
            <div className="lg:col-span-7">
              <h3 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">
                {active.heading}
              </h3>
              <div className="mt-5 space-y-4">
                {active.paragraphs.map((para, idx) => (
                  <p
                    key={`${active.id}-p-${idx}`}
                    className="text-sm leading-loose text-foreground-700 md:text-[15px]"
                  >
                    {para}
                  </p>
                ))}
              </div>
            </div>
            <div className="lg:col-span-5">
              <div className="rounded-lg border border-accent-200 bg-accent-50 p-5 md:p-6">
                <p className="flex items-center gap-2 font-heading text-sm font-bold text-accent-900">
                  <i className="ri-lightbulb-flash-line text-lg" />
                  关键要点
                </p>
                <ul className="mt-4 space-y-3">
                  {active.points.map((point, idx) => (
                    <li key={`${active.id}-k-${idx}`} className="flex items-start gap-2.5 text-sm text-accent-900">
                      <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-accent-600" />
                      <span className="leading-relaxed">{point}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}